import React, { useState, useRef, useEffect } from "react";
import { Box, Stack } from "@mui/material";
import DatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dropdown from "../common/Dropdown";
import Button from "../common/Button";
import CALENDER_ICON from "../../globals/assets/Icon metro-calendar (1).svg";
import "./reports.scss";
import moment from "moment";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API } from "../../globals/constants";
import CsvDownloader from "react-csv-downloader";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import { ToastContainer, toast } from "react-toastify";
// import DownloadImage from '../../Images/Icondownload.png';

const Reports = () => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedValue, setSelectedValue] = useState();
  const datepicker_start_ref = useRef();
  const datepicker_end_ref = useRef();
  const calenderRef = useRef();
  const [loader, setLoader] = useState(false);
  const [vmListing, setVmListing] = useState([]);

  const gotoSpecificDate = (date) => {
    let calendarApi = calenderRef.current.getApi();
    console.log("startDate-------------->>", startDate);
    calendarApi.gotoDate(startDate);
  };

  const openStartDatePicker = () => {
    let ref = datepicker_start_ref.current.onInputClick();
    console.log("startDate", startDate);
  };

  const openEndDatePicker = () => {
    let ref = datepicker_end_ref.current.onInputClick();
    console.log("endDate", endDate);
  };

  const options = [{ value: "vm_report", label: "VM Report" }];

  const dropdownSelect = (value) => {
    setSelectedValue(value);
  };
  const loadReportList = async () => {
    let params = {
      from_date: moment(startDate).format("YYYY-MM-DD"),
      to_date: moment(endDate).format("YYYY-MM-DD"),
    };
    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
        API.END_POINTS.GET_VM_REPORT
      }`,
      params,
      {},
      {}
    );
    if (response.status === 200) {
      setLoader(false);
      let temp = [...response.data.data];
      let dataObject = [];
      let tempData = temp.map((item) => {
        let totalHour = parseFloat(item.total_hr).toFixed(2);
        let trainingHrs = parseFloat(item.training_hrs).toFixed(2);
        dataObject.push({
          instance_count: item.instance_count,
          session_date: item.session_date,
          session_date: moment
            .utc(item.session_date)
            .format("DD-MM-YYYY HH:mm:ss"),
          End_Date: moment.utc(item.End_Date).format("DD-MM-YYYY HH:mm:ss"),
          zone: item.zone,
          student_count: item.student_count,
          studio_name: item.studio_name,
          title: item.title,
          total_hr: totalHour,
          training_hrs: trainingHrs,
          user_id: item.user_id,
        });
        return dataObject;
      });
      setVmListing([...dataObject]);
    } else {
      setLoader(false);
    }
  };

  const handleExport = () => {
    if (startDate && endDate && selectedValue) {
      document.getElementById("export_csv").click();
    } else {
      if (!startDate && !endDate && !selectedValue) {
        toast.error("Please Select Date Range and Report Type", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      } else {
        if (!startDate && !endDate) {
          toast.error("Please Select Date Range", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (!startDate) {
          toast.error("Please Select Start Date", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (!endDate) {
          toast.error("Please Select End Date", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (!selectedValue)
          toast.error("Please Select Report Type", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
      }
    }
  };

  useEffect(() => {
    console.log("selectedValue", selectedValue);

    loadReportList();
    console.log("startDate", startDate);
    console.log("endDate", endDate);
  }, [startDate, endDate]);
  useEffect(() => {
    setEndDate("");
  }, [startDate]);

  return (
    <div id="reports">
      <Stack className="larger_f_bold" margin={"2%"}>
        Reports
      </Stack>
      <Box
        sx={{
          bgcolor: "#232135",
          height: "65vh",
          padding: "4% 8%",
          margin: "2%",
          borderRadius: "5px",
        }}
      >
        {loader ? (
          <MultiLine_Spinner />
        ) : (
          <Stack>
            <Stack>
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={{ xs: "20%", sm: "10%", md: "0%" }}
              >
                <Stack width={{ xs: "100%", md: "50%" }} spacing="2%">
                  <Stack className="fontformat">Start Date</Stack>
                  <Stack>
                    <Box className="reportDatePicker">
                      <span className="alignDatePicker">
                        <DatePicker
                          ref={datepicker_start_ref}
                          closeOnScroll={true}
                          selected={startDate}
                          dateFormat="yyyy/MM/dd"
                          onChange={(date) => setStartDate(date)}
                          onSelect={gotoSpecificDate}
                          placeholderText="YYYY/MM/DD"
                          maxDate={new Date()}
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          //dateFormat="MMMM d, yyyy"
                        />
                      </span>

                      <img src={CALENDER_ICON} onClick={openStartDatePicker} />
                    </Box>
                  </Stack>
                </Stack>

                <Stack width={{ xs: "100%", md: "50%" }} spacing="2%">
                  <Stack className="fontformat">End Date</Stack>
                  <Stack>
                    <Box className="reportDatePicker">
                      <span className="alignDatePicker">
                        <DatePicker
                          ref={datepicker_end_ref}
                          closeOnScroll={true}
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          onSelect={gotoSpecificDate}
                          dateFormat="yyyy/MM/dd"
                          placeholderText="YYYY/MM/DD"
                          maxDate={new Date()}
                          minDate={startDate}
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                        />
                      </span>

                      <img src={CALENDER_ICON} onClick={openEndDatePicker} />
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              width={"90%"}
              marginTop={{ xs: "20%", sm: "10%", md: "6%" }}
              spacing="1%"
            >
              <Stack className="fontformat">Report Type</Stack>
              <Stack borderRadius={20}>
                <Dropdown
                  placeholder={"Select Report Type"}
                  options={options}
                  onChange={(selected) => dropdownSelect(selected)}
                />
              </Stack>
            </Stack>
            <Stack display={"none"}>
              <CsvDownloader
                id="export_csv"
                filename="vm_report.csv"
                separator=","
                columns={[
                  { displayName: "Training center name", id: "studio_name" },
                  {
                    displayName: "Session start date(UTC)",
                    id: "session_date",
                  },
                  { displayName: "Session end date(UTC)", id: "End_Date" },
                  { displayName: "Session end date(UTC)", id: "End_Date" },
                  { displayName: "Zone", id: "zone" },
                  {
                    displayName: "Title",
                    id: "title",
                  },
                  {
                    displayName: "Total hours of instance running",
                    id: "total_hr",
                  },
                  { displayName: "Total training hours", id: "training_hrs" },
                  {
                    displayName: "No. of Student",
                    id: "student_count",
                  },
                  {
                    displayName: "No. of Instance",
                    id: "instance_count",
                  },
                ]}
                wrapColumnChar=""
                datas={vmListing}
                // disabled={startDate && endDate ? false : true}
              >
                {/* <Stack width={'15%'} marginTop={{ xs: '10%', md: '4%' }}>
								<Button
									role="primary"
									value="Download"
									// onClick={() => handleExport}
									className="approval_edit"
									disabled={startDate && endDate ? false : true}
								/>
							</Stack> */}
              </CsvDownloader>
            </Stack>
            <Stack width={"15%"} marginTop={{ xs: "10%", md: "4%" }}>
              <Button
                //style={{ display: showFilter ? 'none' : 'contents' }}
                value={"Download"}
                role="add"
                onClick={() => {
                  handleExport();
                }}
                // disabled={startDate && endDate && selectedValue ? false : true}
              />
              {/* <img src={DownloadImage} /> */}
            </Stack>
          </Stack>
        )}
      </Box>
    </div>
  );
};

export default Reports;
